import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Home, Search, ArrowLeft } from 'lucide-react';
import SEO from '../components/SEO';

const NotFoundPage = () => {
  return (
    <main className="pt-28 min-h-screen bg-gray-50 flex items-center justify-center">
      <SEO title="Pagina niet gevonden - Staffing Force" description="De pagina die u zoekt bestaat niet of is verplaatst." />
      <div className="max-w-lg mx-auto px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="text-[#00897B] text-9xl font-black mb-4">404</div>
          <h1 className="text-3xl font-bold text-gray-900 mb-4">Pagina niet gevonden</h1>
          <p className="text-gray-600 mb-8">De pagina die u zoekt bestaat niet of is verplaatst. Gebruik de onderstaande links om verder te navigeren.</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/" className="bg-[#00897B] hover:bg-[#00796B] text-white px-6 py-3 rounded font-semibold text-sm transition-all flex items-center justify-center gap-2">
              <Home size={16} /> Naar de homepage
            </Link>
            <Link to="/vacatures" className="border border-gray-200 text-gray-700 px-6 py-3 rounded font-semibold text-sm hover:border-[#00897B] hover:text-[#00897B] transition-all flex items-center justify-center gap-2">
              <Search size={16} /> Bekijk vacatures
            </Link>
          </div>
          <div className="mt-12 grid grid-cols-2 gap-4 text-left">
            <Link to="/over-ons" className="p-4 bg-white rounded-lg border border-gray-100 hover:border-[#00897B]/30 transition-colors group">
              <h3 className="font-semibold text-gray-900 group-hover:text-[#00897B] text-sm">Over ons</h3>
              <p className="text-xs text-gray-500 mt-1">Leer ons kennen</p>
            </Link>
            <Link to="/diensten" className="p-4 bg-white rounded-lg border border-gray-100 hover:border-[#00897B]/30 transition-colors group">
              <h3 className="font-semibold text-gray-900 group-hover:text-[#00897B] text-sm">Diensten</h3>
              <p className="text-xs text-gray-500 mt-1">Wat wij bieden</p>
            </Link>
            <Link to="/voor-kandidaten" className="p-4 bg-white rounded-lg border border-gray-100 hover:border-[#00897B]/30 transition-colors group">
              <h3 className="font-semibold text-gray-900 group-hover:text-[#00897B] text-sm">Voor kandidaten</h3>
              <p className="text-xs text-gray-500 mt-1">Jouw volgende stap</p>
            </Link>
            <Link to="/contact" className="p-4 bg-white rounded-lg border border-gray-100 hover:border-[#00897B]/30 transition-colors group">
              <h3 className="font-semibold text-gray-900 group-hover:text-[#00897B] text-sm">Contact</h3>
              <p className="text-xs text-gray-500 mt-1">Neem contact op</p>
            </Link>
          </div>
        </motion.div>
      </div>
    </main>
  );
};

export default NotFoundPage;
